import React, { useState } from 'react';
import classNames from 'classnames';
import Link from 'next/link';

import { ISubNav } from '@/components/Nav/utilities';

const MobileNavPanel = ({
  desktop,
  items,
  closeMenu,
  categoryName,
}: {
  desktop?: boolean;
  items: ISubNav[];
  closeMenu: () => void;
  categoryName: string;
}) => {
  const [activeTab, setActiveTab] = useState<number | null>(desktop ? 0 : null);

  const toggleTab = (index: number) => {
    setActiveTab(activeTab === index ? null : index);
  };

  return (
    <div className="overflow-auto md:flex">
      <p className="p-4 font-semibold">{categoryName}</p>
      <ul className="flex flex-col border-background-3">
        {items.map((category, index) => (
          <li key={category.name} className="border-b border-background-3">
            <button
              className="text-md w-full cursor-pointer px-4 py-3 text-left transition-colors hover:bg-background"
              onClick={() => toggleTab(index)}
            >
              {category.name}
            </button>
            {activeTab === index && (
              <ul className="mt-2 space-y-2 px-4 md:hidden">
                {category.items.map((item) => (
                  <li key={item.name}>
                    <Link
                      href={item.href}
                      className="block w-full cursor-pointer p-2 text-left transition-colors hover:bg-background"
                      onClick={() => closeMenu()}
                    >
                      <p className="mb-1 text-base font-medium">{item.name}</p>
                      <p className="text-sm text-secondary">
                        {item.description}
                      </p>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileNavPanel;
